// Registro resiliente do Service Worker Essencial para PWA

export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  // Se o app estiver sendo executado dentro de um iframe no ambiente de desenvolvimento,
  // navegadores Chromium barram o registro de Service Worker se o subdomínio de preview
  // passar por checagem de cookies/redirecionamento HTTP no proxy do iframe.
  const isInsideIframe = window.self !== window.top;
  const isPreviewHost = window.location.hostname.includes('.run.app') || window.location.hostname.includes('localhost');

  window.addEventListener('load', () => {
    // Testa primeiro se o recurso /sw.js está acessível diretamente sem redirecionamento 30x
    fetch('/sw.js', { method: 'HEAD', cache: 'no-store' })
      .then((res) => {
        // Se a resposta redirecionou ou não foi 200/OK, navegadores rejeitam o SW
        if (res.redirected) {
          console.debug('Cardumy: Registro de Service Worker ignorado pois o script /sw.js está atrás de redirecionamento.');
          return;
        }

        if (!res.ok) {
          console.debug('Cardumy: /sw.js não disponível no momento (status:', res.status, ')');
          return;
        }

        // Registra o Service Worker com escopo na raiz
        navigator.serviceWorker
          .register('/sw.js', { scope: '/' })
          .then((registration) => {
            registration.onupdatefound = () => {
              const installingWorker = registration.installing;
              if (installingWorker == null) return;

              installingWorker.onstatechange = () => {
                if (installingWorker.state === 'installed') {
                  if (navigator.serviceWorker.controller) {
                    console.info('Cardumy: Nova versão disponível em segundo plano.');
                  } else {
                    console.info('Cardumy: Conteúdo em cache para uso offline.');
                  }
                }
              };
            };
          })
          .catch((error) => {
            // Em caso de erro de redirecionamento gerado pelo proxy ou ambiente de preview
            if (String(error).toLowerCase().includes('redirect') || isInsideIframe || isPreviewHost) {
              console.debug('Cardumy: Service Worker ignorado no ambiente atual:', error?.message || error);
            } else {
              console.warn('Cardumy: Aviso no registro do Service Worker:', error);
            }
          });
      })
      .catch((err) => {
        console.debug('Cardumy: Verificação de /sw.js ignorada:', err);
      });
  });
}

export function unregisterServiceWorker() {
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
